import React from 'react';
import TimeRangePicker from '@wojtekmaj/react-timerange-picker';
import { convertTimeStringToReadable } from '../../lib/utils';

class TimeRangeSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: props.time,
    };
  }

  onChange = (time) => {
    const { onChange } = this.props;
    this.setState({ time });
    onChange(time);
  }

  render() {
    const { time } = this.state;
    const [startTime, endTime] = time;
    const startStr = convertTimeStringToReadable(startTime);
    const endStr = convertTimeStringToReadable(endTime);
    return (
      <div>
        <p>
          {!startTime && !endTime && 'Please select the starting time.'}
          {startTime && !endTime && 'Please select the ending time.'}
          {startTime
            && endTime
            && `Selected from ${startStr} to ${endStr}`}
        </p>
        <TimeRangePicker
          onChange={this.onChange}
          value={time}
          disableClock
          format="h:m a"
        />
      </div>
    );
  }
}

export default TimeRangeSelector;
